import req from "./request.config";
import axios from "axios";
import {
  Loading
} from "element-ui";

let request = {
  post: function (url, params, callback, errCallback) {
    return axios
      .post(url, params, {
        headers: {},
        timeout: 30000,
        withCredentials: true
      })
      .then(res => {
        if (res.data.success) {
          callback(res.data);
        } else {
          errCallback && errCallback(res);
        }
      })
      .catch(err => {
      });
  },
  get: function (url, params, callback, errCallback, netErrCallback) {
    let t = new Date().getTime();
    let n = url.indexOf("?");
    if (n == "-1") {
      url = url + "?" + t;
    } else {
      url = url + "&" + t;
    }
    return axios({
      url: url,
      params: params,
      method: "get",
      withCredentials: true,
      timeout: 30000
    })
      .then(res => {
        if (res.data.success) {
          callback(res.data);
        } else {
          errCallback && errCallback(res);
        }
      })
      .catch(err => {
        netErrCallback && netErrCallback(err);
      });
  },
  del: function (url, params, callback, errCallback) {
    return axios({
      url: url,
      method: "delete",
      baseURL: "",
      data: params,
      withCredentials: true,
      headers: {},
      timeout: 30000
    })
      .then(res => {
        if (res.data.success) {
          callback(res.data);
        } else {
          errCallback(res);
        }
      })
      .catch(err => {
      });
  },
  put: function (url, params, callback, errCallback) {
    return axios
      .put(url, params, {
        headers: {},
        timeout: 30000,
        withCredentials: true
      })
      .then(res => {
        if (res.data.success) {
          callback(res.data);
        } else {
          errCallback && errCallback(res);
        }
      })
      .catch(err => {
      });
  },
  downloadFileUrl: function (url, params, method = "get", headers = {
    responseType: 'blob'
  }) {
    let data = {};
    let paramsData = {};
    if (method == 'get') {
      paramsData = params;
    } else {
      data = params;
    }
    return axios({
      url,
      params: paramsData,
      data: data,
      headers: headers,
      timeout: 30000,
      withCredentials: true,
      responseType: 'blob',
      method: method
    })
      .then(res => {
        let filename = res.headers["content-disposition"];
        filename = filename.replace('"', "").replace('"', "").replace('"', "").replace('"', "");
        filename = filename.split(";")[1];
        console.log(filename);
        let fileDownloadName = "";
        if (filename.indexOf('filename=') != -1) {
          fileDownloadName = filename.split("filename=")[1];
        } else {
          fileDownloadName = filename.split("fileName=")[1];
        }
        let arr = fileDownloadName.split('.');
        let blobType = "application/" + arr[arr.length - 1];
        if (/\.pdf/gi.test(filename)) {
          blobType = "application/pdf";
        } else if (/\.jpg/gi.test(filename)) {
          blobType = "image/jpg";
        } else if (/\.bmp/gi.test(filename)) {
          blobType = "image/bmp";
        } else if (/\.jpeg/gi.test(filename)) {
          blobType = "image/jpeg";
        } else if (/\.gif/gi.test(filename)) {
          blobType = "image/gif";
        } else if (/\.tif/gi.test(filename)) {
          blobType = "image/tif";
        } else if (/\.webp/gi.test(filename)) {
          blobType = "image/webp";
        } else if (/\.zip/gi.test(filename)) {
          blobType = "application/zip";
        }
        const blob = new Blob([res.data], {
          type: blobType
        });

        console.log(fileDownloadName);
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = decodeURIComponent(fileDownloadName);
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      })
      .catch(err => {
        console.log(err)
      });
  }
};

let obj = {};
obj.install = function (Vue, option) {
  Vue.prototype.$getDict = async function (code) {
    let res = await req.get("/security/web/sysdict/selectListByTypeCodeV3", {
      dictTypeCode: code
    });
    return res.data.data;
  };
  Vue.prototype.$getParkList = async function () {
    let res = await req.get("/security/forrecruitpark/user/park", {});
    return res.data.data;
  };
  Vue.prototype.$getAllParkList = async function () {
    let res = await req.get("security/forrecruitpark/park/list", {});
    return res.data.data;
  };
  Vue.prototype.$getOnlineParkList = async function () {
    let res = await req.get("/security/personnel/common/park/list", {});
    return res.data.data;
  };

  Vue.prototype.$get = req.get;
  Vue.prototype.$post = req.post;
  Vue.prototype.$delete = req.delete;
  Vue.prototype.$put = req.put;
  Vue.prototype.$downloadFileUrl = req.downloadFileUrl;
  Vue.prototype.get = request.get;
  Vue.prototype.post = request.post;
  Vue.prototype.del = request.del;
  Vue.prototype.put = request.put;
  Vue.prototype.downloadFileUrl = request.downloadFileUrl;
  const translator = new Vue({
    methods: {
      emit(event, ...arg) {
        this.$emit(event, ...arg);
      },
      on(event, callback) {
        this.$on(event, callback);
      },
      off(event, callback) {
        this.$off(event, callback);
      }
    }
  });
  Vue.prototype.$bus = translator;
  Vue.prototype.$deleteByType = function (
    type,
    count,
    confirmFn,
    errFn,
    confirmFnParams
  ) {
    let obj = {
      checkByCount: "是否确认审核选中的",
      checkByCondition: "是否确认审核查询范围内的",
      count: "是否确认删除选中的",
      condition: "是否确认删除查询范围内的",
      moveByCount: "是否确认移动选中的",
      moveByCondition: "是否确认移动查询范围内的",
      authenticateFaceByCount: "是否人脸认证选中的",
      authenticateFaceByCondition: "是否人脸认证查询范围内的",
      authenticateFingerPrintByCount: "是否指纹认证选中的",
      authenticateFingerPrintByCondition: "是否指纹认证查询范围内的",
      trainingOk: "是否培训通过选中的",
      trainingNG: "是否培训不通过选中的"
    };
    let message;
    if (typeof type == "object") {
      message = type.message;
    } else {
      message = obj[type];
    }
    Vue.prototype
      .$confirm(
        `<p style="text-align:center">${message}<span  style="color:red;"> ${count} </span>条数据<div style="text-align:center;color:#bcbcbc">(操作后不可恢复)</div></p>`,
        "提示", {
          confirm: "确定",
          cancel: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true
        }
      )
      .then(() => {
        typeof confirmFn == "function" &&
        confirmFnParams &&
        confirmFn(confirmFnParams);
        typeof confirmFn == "function" && !confirmFnParams && confirmFn();
      })
      .catch(err => {
        typeof errFn == "function" && errFn();
      });
  };
  Vue.prototype.$emptifyObj = function (obj) {
    for (let n in obj) {
      delete obj[n];
    }
  };
};
export default obj;



// WEBPACK FOOTER //
// ./src/utils/dict.config.js